var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ingIcon1",
    transform: "translate(-993 -317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6193",
    "data-name": "\\uC0AC\\uAC01\\uD615 6193",
    width: 90,
    height: 90,
    rx: 45,
    transform: "translate(993 317)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ing1",
    transform: "translate(1014.999 338.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34136",
    "data-name": "\\uD328\\uC2A4 34136",
    d: "M6.149,353.043.035,365.7a.335.335,0,0,0,.447.447l12.662-6.114,1.252-1.252L7.4,351.791Z",
    transform: "translate(0 -320.183)",
    fill: "#fed9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34137",
    "data-name": "\\uD328\\uC2A4 34137",
    d: "M.481,439.151l6.707-3.239L3.273,432,.035,438.7A.335.335,0,0,0,.481,439.151Z",
    transform: "translate(0 -393.182)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34138",
    "data-name": "\\uD328\\uC2A4 34138",
    d: "M1.105,401.509a.329.329,0,0,0,.382.065l12.662-6.114,1.252-1.252-3.5-3.5Z",
    transform: "translate(-1.006 -355.605)",
    fill: "#f4c892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34139",
    "data-name": "\\uD328\\uC2A4 34139",
    d: "M1.105,458.914a.329.329,0,0,0,.382.065l6.707-3.239-1.957-1.957Z",
    transform: "translate(-1.006 -413.01)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34140",
    "data-name": "\\uD328\\uC2A4 34140",
    d: "M107.095,1.448h0a4.945,4.945,0,0,1,0,6.994L75.708,39.829l-6.994-6.994L100.1,1.448A4.945,4.945,0,0,1,107.095,1.448Z",
    transform: "translate(-62.54 0)",
    fill: "#ffbf14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34141",
    "data-name": "\\uD328\\uC2A4 34141",
    d: "M148.335,4.561h0a4.924,4.924,0,0,0-1.781-1.141,4.945,4.945,0,0,1-1.141,5.212L114.026,40.019l2.923,2.923,31.387-31.387A4.945,4.945,0,0,0,148.335,4.561Z",
    transform: "translate(-103.781 -3.113)",
    fill: "#ff901d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6196",
    "data-name": "\\uC0AC\\uAC01\\uD615 6196",
    width: 9.891,
    height: 3.765,
    transform: "translate(34.855 4.155) rotate(45)",
    fill: "#21d8de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6197",
    "data-name": "\\uC0AC\\uAC01\\uD615 6197",
    width: 4.184,
    height: 3.765,
    transform: "translate(38.89 8.189) rotate(45)",
    fill: "#11b9c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34142",
    "data-name": "\\uD328\\uC2A4 34142",
    d: "M397.622,1.448h0a4.945,4.945,0,0,0-6.994,0l-2.706,2.706,6.994,6.994,2.706-2.706A4.945,4.945,0,0,0,397.622,1.448Z",
    transform: "translate(-353.067 0)",
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34143",
    "data-name": "\\uD328\\uC2A4 34143",
    d: "M438.648,4.5h0a4.924,4.924,0,0,0-1.8-1.147,4.945,4.945,0,0,1-1.147,5.2L433,11.258l2.944,2.944,2.706-2.706A4.945,4.945,0,0,0,438.648,4.5Z",
    transform: "translate(-394.093 -3.054)",
    fill: "#f33939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6198",
    "data-name": "\\uC0AC\\uAC01\\uD615 6198",
    width: 3.302,
    height: 36.796,
    transform: "translate(10.838 37.5) rotate(-135)",
    fill: "#ffb123"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngIcon1);
export default __webpack_public_path__ + "static/media/ingIcon1.ec0cfc401af28c283670d6dd8bb4cdbc.svg";
export { ForwardRef as ReactComponent };